import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imagen-modal',
  templateUrl: './imagen-modal.component.html',
  styleUrls: ['./imagen-modal.component.css']
})
export class ImagenModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
